import React from 'react';
import Education from './Education';
import Experience from './Experience';
import "../../assets/style/Qualification.css";

const Qualification: React.FC = () => {
  return (
    <div>
      <section className="qualification section" id='qualification'>
      <div className='contenu'>
        <h2 data-heading="Mon journal" className="section__title">Qualification</h2>

        <div className="qualification__container grid">
          <Education />

          <Experience />
        </div>
        </div>
      </section>
    </div>
  );
};

export default Qualification;